<template>
  <div class="col-big-vbspace basic-form">
    <div
      class="col-vspace flex-radio"
      :class="active !== 'list' ? 'flex-radio--disabled' : false"
    >
      <div class="flex-radio__input">
        <input
          type="radio"
          name="type-choice"
          value="list"
          id="type-choice-list"
          v-model="active"
        >
        <label for="type-choice-list" class="flex-radio__input__box"></label>
      </div>
      <div class="flex-radio__data">
        <label class="label--textarea" for="choice-list">Je choisis dans la liste</label>
        <select
          name="choice-list"
          id="choice-list"
          class="classic-select tcenter"
          v-model="selectMessage"
          @focus="focusSelect"
        >
          <option value="">CHOISISSEZ ICI ...</option>
          <option
            v-for="(option, index) in options"
            :value="option.value"
            :key="index"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>

    <p class="big-title bold">OU</p>

    <div
      class="col-vspace flex-radio"
      :class="active !== 'own' ? 'flex-radio--disabled' : false"
    >
      <div class="flex-radio__input">
        <input
          type="radio"
          name="type-choice"
          value="own"
          id="type-choice-own"
          v-model="active"
          @focus="focusInput"
        >
        <label for="type-choice-own" class="flex-radio__input__box"></label>
      </div>
      <div class="flex-radio__data">
        <div>
          <label class="label--textarea" for="choice-list">Mon idée géniale pour la <u>1ère ligne</u> (max. {{ maxLengthTop }} caractères)</label>
          <input
            type="text"
            class="classic-input tupper"
            v-model="topMessage"
            :maxlength="maxLengthTop"
            @focus="focusInput"
            @blur="backName"
          >
        </div>

        <div>
          <label class="label--textarea" for="choice-list">Mon idée géniale pour la <u>2ème ligne</u> (max. {{ maxLengthBottom }} caractères)</label>
          <input
            type="text"
            class="classic-input tupper"
            v-model="bottomMessage"
            :maxlength="maxLengthBottom"
            @focus="focusInput"
            @blur="backName"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Mon idée géniale',
    },

    options: {
      type: Array,
      default: () => [],
    },

    maxLengthTop: {
      type: Number,
      default: 24,
    },

    maxLengthBottom: {
      type: Number,
      default: 24,
    },
  },

  data() {
    return {
      maxLength: 20,
      active: 'list',
      default: '',
      selectMessage: '',
      topMessage: '',
      bottomMessage: '',
    };
  },

  created() {
    this.default = this.message;
  },

  watch: {
    selectMessage() {
      this.changeName();
    },

    active() {
      this.$emit('change-name', this.active === 'list' ? this.selectMessage : this.innerMessage);
    },

    innerMessage() {
      this.$emit('change-name', this.innerMessage);
    },
  },

  computed: {
    innerMessage() {
      return `${this.topMessage.toUpperCase()} | ${this.bottomMessage.toUpperCase()}`;
    },
  },

  methods: {
    resetName() {
      if (this.message === this.default) {
        this.$emit('change-name', '');
      }
    },
    backName() {
      if (this.message === '') {
        this.$emit('change-name', this.default);
      }
    },

    changeName() {
      this.default = this.selectMessage;
      this.$emit('change-name', this.selectMessage);
    },

    focusInput() {
      this.active = 'own';
      this.resetName();
    },

    focusSelect() {
      this.active = 'list';
    },
  },
};
</script>
